// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/scripts/bundle." + "021dab45ea4cc336a996" + ".js";
};